var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0,
    fill: "currentColor",
    viewBox: "0 0 52 52",
    width: "8em",
    height: "8em",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.0968C5 7.72962 7.72962 5 11.0968 5h29.8064C44.2704 5 47 7.72962 47 11.0968v13.5484c0 3.3671-2.7296 6.0967-6.0968 6.0967H11.0968C7.72962 30.7419 5 28.0123 5 24.6452V11.0968Zm6.0968-2.03228c-1.12241 0-2.03228.90987-2.03228 2.03228v13.5484c0 1.1223.90987 2.0322 2.03228 2.0322h29.8064c1.1224 0 2.0323-.9099 2.0323-2.0322V11.0968c0-1.12241-.9099-2.03228-2.0323-2.03228H11.0968ZM5 36.8387c0-1.1224.90987-2.0322 2.03226-2.0322H44.9677c1.1224 0 2.0323.9098 2.0323 2.0322 0 1.1224-.9099 2.0323-2.0323 2.0323H7.03226C5.90987 38.871 5 37.9611 5 36.8387Zm0 8.129c0-1.1223.90987-2.0322 2.03226-2.0322H44.9677c1.1224 0 2.0323.9099 2.0323 2.0322C47 46.0901 46.0901 47 44.9677 47H7.03226C5.90987 47 5 46.0901 5 44.9677Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList);
export default __webpack_public_path__ + "static/media/view_list.7c117d6397f496a38b753f5f69b54d29.svg";
export { ForwardRef as ReactComponent };